// extracted by mini-css-extract-plugin
export default {"video-section":"q_bC d-flex","video-section--header":"q_bD","video-section__frame":"q_bF ml-3"};